import { resolveEls } from "./resolve-el.js";
export function setText(selectors, value) {
    return setProperty(`textContent`, selectors, value);
}
;
export function setHtml(selectors, value) {
    return setProperty(`innerHTML`, selectors, value);
}
;
export function setProperty(property, selectors, value) {
    let elements = [];
    const set = (v) => {
        const typ = typeof v;
        const vv = (typ === `string` || typ === `number` || typ === `boolean`) ? v :
            JSON.stringify(v);
        if (elements.length === 0) {
            elements = resolveEls(selectors);
        }
        for (const element of elements) {
            element[property] = vv;
        }
        return vv;
    };
    return value === undefined ? set : set(value);
}
;
